import Button from './button';
import ButtonGroup from './button-group';
Button.Group = ButtonGroup;
export default Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/button/index.js
// module id = 147
// module chunks = 0